import { useAuthConfigStore } from '@phx-husky/auth-context';
import Auth from '@phx-husky/auth-service';
import { useRef } from 'react';

const useAuth = () => {
    const { services, config } = useAuthConfigStore();
    const { current: huskyAuth } = useRef(Auth.getInstance(services, config));
    return huskyAuth;
};

export { useAuth };
